import React from "react";
import ReactDom from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useState } from "react";
import { IoCloseSharp, IoArrowBackSharp } from "react-icons/io5";
import Success from "./Message";
import { useCreateEmailSubscribeMutation } from "../../../redux/slices/emailSubscribeSlice";
import { useEffect } from "react";
import Loader from "../../../component/loader";
import mixpanel from "mixpanel-browser";
import { useAppContext } from './../../../util'

const OVERLAY_STYLES = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, .7)",
  zIndex: 1000,
};

function EmailBox({ open, onClose, data, type, listId, tags, privacyLink }) {
  const { userId, pageId } = useAppContext()
  if (!open) return null;
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(null);
  const [emailError, setEmailError] = useState("")
  const [createEmailSubscribeApi, { isLoading, isError, error, isSuccess }] =
    useCreateEmailSubscribeMutation();

  const handleEmail = (e) => {
    setEmail(e.target.value);
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value)) {
      setEmailError("");
    } else {
      setEmailError("Invalid Email!");
    }
  };
  const handleValidEmail = async (e) => {
    e.preventDefault();
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setEmailError("Invalid Email!");
      return;
    }

    const formData = {
      email,
      listId,
    };
    type === "mailchimp" && tags !== ""
      ? (formData.tags = tags.split(",").map((item) => item.trim()))
      : "";
    const response = await createEmailSubscribeApi({
      emailUrl:
        type === "mailchimp"
          ? `mailchimp/subscribe-email/${userId}`
          : `klaviyo/subscribe-email/${userId}`,
      data: formData,
    }).unwrap();
    if (response.success) {
      mixpanel.track(
        "Web Email Subscribed", 
        {
          distinct_id: userId,
          stack_id: pageId,
        }
      )
    }
    setSuccess(response);
  };

  const handleBackButton = () => {
    setSuccess(null);
  };

  return ReactDom.createPortal(
    <>
      <div style={OVERLAY_STYLES} />
      <div style={{ padding: "16px" }}>
        <div className="modal-container">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "32px",
              fontFamily: "Inter",
            }}
          >
            {isError && (
              <span
                style={{
                  padding: "10px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0px 1px 1px 0px #3031331A",
                }}
                onClick={handleBackButton}
              >
                <IoArrowBackSharp
                  style={{
                    fontSize: "13.33px",
                    fontWeight: 900,
                    lineHeight: "13.33px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                />
              </span>
            )}
            <span
              style={{
                fontSize: "1rem",
                fontWeight: 600,
                lineHeight: "20px",
                textAlign: "center",
                margin: "10px auto",
              }}
            >
              {data?.headingText}
            </span>
            <span
              style={{
                padding: "10px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 1px 1px 0px #3031331A",
              }}
              onClick={() => onClose(false)}
            >
              <IoCloseSharp
                style={{
                  fontSize: "13.33px",
                  fontWeight: 900,
                  lineHeight: "13.33px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              />
            </span>
          </div>

          {success === null && !isLoading && (
            <div className="email-controller">
              <div className="input-wrapper">
                <input
                  type="email"
                  className="custom-input"
                  style={{
                    border: emailError && "1px solid red",
                  }}
                  placeholder="youremail@site.com"
                  value={email}
                  onChange={handleEmail}
                />

                <label className="custom-label">Email</label>
              </div>

              <button
                style={{
                  display: "flex",
                  borderRadius: "16px",
                  padding: "3px 12px",
                  justifyContent: "start",
                  background: "#1F2937",
                  border: "none",
                  cursor: "pointer",
                  width: "100%",
                  alignItem: "center",
                }}
                onClick={handleValidEmail}
              >
                <div
                  style={{
                    gap: "1rem",
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1rem",
                      color: "white",
                    }}
                  >
                    <FontAwesomeIcon icon="fa-sharp fa-solid fa-check" />
                  </p>
                  <p
                    style={{
                      fontSize: "1rem",
                      fontWeight: 500,
                      color: "white",
                      fontFamily: "Inter",
                    }}
                  >
                    {data?.submitButtonText}
                  </p>
                </div>
              </button>

              {privacyLink && (
                <a
                  href={privacyLink}
                  target="_blank"
                  style={{
                    margin: "0px auto",
                    textDecoration: "inline",
                    color: "#111827",
                    fontFamily: "Inter",
                    fontSize: "12px",
                  }} rel="noreferrer"
                >
                  Privacy policy
                </a>
              )}
            </div>
          )}

          {isLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader width={"50px"} />
            </div>
          )}
          {isSuccess && <Success text={data?.confirmText} valid={true} />}
          {isError && success && (
            <Success text="An error occurred, please try again" valid={false} />
          )}
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
}

// export component Card

export default EmailBox;
